import { CSSProperties, memo } from 'react'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface Props {
  direction: 'next' | 'prev'
  progress: number
  isLoading: boolean
}

interface SwipeIndicatorStyles extends CSSProperties {
  '--swipe-offset': string
  '--swipe-progress': number
  '--swipe-scale': number
}

const ArrowDirectionComponent = ({ direction, progress, isLoading }: Props) => {
  const indicatorProgress = isLoading ? 1 : progress
  const offset = (1 - indicatorProgress) * (direction === 'next' ? 8 : -8)
  const scale =
    0.85 + indicatorProgress * 0.15 + (indicatorProgress === 1 ? 0.08 : 0)
  const style: SwipeIndicatorStyles = {
    '--swipe-offset': `${offset}px`,
    '--swipe-progress': indicatorProgress,
    '--swipe-scale': scale,
  }

  return (
    <div
      className={clsx(s.container, {
        [s.next]: direction === 'next',
        [s.prev]: direction === 'prev',
        [s.ready]: indicatorProgress === 1,
      })}
      style={style}
      aria-hidden
    >
      {isLoading ? (
        <span className={s.spinner} />
      ) : (
        <span className={s.arrows}>
          <AppIcon
            id={AllIcons.ARROW_BOTTOM}
            width={24}
            height={24}
          />
        </span>
      )}
    </div>
  )
}

export const ArrowDirection = memo(ArrowDirectionComponent)
